import CardPaymentService from "./CardPaymentService"
export default CardPaymentService
